import { gql } from "@apollo/client";

export const getEulaInfo = gql`
    query getEulaInfo {
        cameraKitMe {
            me {
                hasAgreedToLatestEula
                latestEulaId
                latestEulaUrl
            }
        }
    }
`;
